import { createContext, useContext, useState } from 'react';
import { TActionState } from '../routes/customer/return/interface';

const initialState: TActionState = {
  state: 'LIST',
  data: undefined,
  filter: undefined,
  back: 'LIST',
};

const ReturnStateContext = createContext<{
  actionState: TActionState;
  setActionState: React.Dispatch<React.SetStateAction<TActionState>>;
} | null>(null);

export const ReturnStateProvider = ({ children }: { children: React.ReactNode }) => {
  const [actionState, setActionState] = useState<TActionState>(initialState);

  return <ReturnStateContext.Provider value={{ actionState, setActionState }}>{children}</ReturnStateContext.Provider>;
};

export const useReturnState = () => useContext(ReturnStateContext);
